module.exports = __webpack_public_path__ + "img/box-right.7fa6d89f.png";